export default __webpack_public_path__ + "static/media/Kel'Avashk Sandals.7c52e604.jpg";